import { useEffect } from 'react'
import { useGetList, FilterList, FilterListItem, useListContext } from 'react-admin'
import { Box, Chip } from '@mui/material'
import HomeWorkRoundedIcon from '@mui/icons-material/HomeWorkRounded'

const formatDate = (date) => date.toISOString().split('T')[0]

const HippocastListFilter = ({ selectedMonth }) => {
  const { data: centersData } = useGetList(
    'centers',
    {
      pagination: { page: 1, perPage: 50 },
      sort: { field: 'name', order: 'ASC' },
    }
  )
  
  const excludedNames = [
    'CAP CRC', 'CAP IRA', 'CAP TA', 'Artec Formation', 'PRO SAP FORMATIONS', 'Azap Formation', 'Capavocat', 'EDN Hippocrate',
    'INFPS-Campus', 'Mission Avocat', 'Mission Droit', 'Mission Magistrat', 'MyPrepa', 'SupOrtho', 'Symphonie Accompagnements',
    'Étudiant en droit', 'Supexam Paris'
  ].map(name => name.toLowerCase())

  const data = centersData?.filter(center => 
    !excludedNames.includes(center.name?.toLowerCase())
  )

  // Set default filter when data is loaded and no filter is selected
  const { filterValues, setFilters } = useListContext()

  useEffect(() => {
    let currentFilters = { ...filterValues }

    // filter by center
    if (data && !currentFilters.center_id) {
      currentFilters.center_id = process.env.REACT_APP_CENTER_GLOBAL
    }

    // month → @and
    let dateSelected = false
    if (selectedMonth) {
      dateSelected = true
      const [year, month] = selectedMonth.split('-')
      const startDate = new Date(parseInt(year), parseInt(month) - 1, 1)
      const endDate = new Date(parseInt(year), parseInt(month), 0)

      currentFilters['@and'] = {
        'created_at@gte': formatDate(startDate),
        'created_at@lte': formatDate(endDate)
      }
    } else if (currentFilters['@and']) {
      const { ['@and']: _, ...rest } = currentFilters
      currentFilters = rest
    }

    const centerGlobal = currentFilters.center_id === process.env.REACT_APP_CENTER_GLOBAL

    let isGlobal, isMonthly
    if (currentFilters.center_id && !centerGlobal) {
      // per center
      isGlobal = { 'is_global': 0 }
      isMonthly = { 'is_monthly': 0 }

      if (dateSelected) {
        isMonthly = { 'is_monthly': 1 }
      }
    } else {
      // global
      isGlobal = { 'is_global': 1 }
      isMonthly = { 'is_monthly': 0 }

      if (dateSelected) {
        isMonthly = { 'is_monthly': 1 }
      }
    }

    currentFilters = { ...currentFilters, ...isGlobal, ...isMonthly }

    if (JSON.stringify(currentFilters) !== JSON.stringify(filterValues)) {
      setFilters(currentFilters, undefined, true)
    }
  }, [selectedMonth, data, filterValues.center_id, setFilters])

  // Block the no-selection
  const isSelected = (value, filters) => {
    return filters.center_id === value.center_id
  }

  const toggleFilter = (value, filters) => {
    // If trying to deselect the current center, keep it selected
    if (filters.center_id === value.center_id) {
      return filters
    }

    // Otherwise, switch to the new center
    return {
      ...filters,
      center_id: value.center_id
    }
  }

  return (
    <Box width="15em" order="-1" marginRight="1em">
      <FilterList label="Trier par centres" icon={<HomeWorkRoundedIcon />}>
        {data?.map(center => (
          <FilterListItem
            key={center.id}
            label={
              <Chip
                label={center.name}
                size="small"
                style={{
                  backgroundColor: center.color,
                  border: 0,
                  cursor: 'pointer'
                }}
              />
            }
            value={{ center_id: center.id }}
            isSelected={isSelected}
            toggleFilter={toggleFilter}
          />
        ))}
      </FilterList>
    </Box>
  )
}

export default HippocastListFilter